import { debounce } from './global.js';

class CartPageItems extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('[data-cart-page-body]');

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-quantity-increase]')) this.changeQuantityByStep(event, 1);
      if (event.target.closest('[data-quantity-decrease]')) this.changeQuantityByStep(event, -1);
      if (event.target.closest('[data-cart-remove]')) this.removeItem(event);
    });

    this.addEventListener(
      'input',
      debounce((event) => {
        if (event.target.matches('[data-quantity-input]')) this.setQuantity(event);
      }, 400)
    );
  }

  async changeQuantityByStep(event, step) {
    const item = event.target.closest('[data-cart-item]');
    const input = item.querySelector('[data-quantity-input]');
    const newQty = Math.max(0, parseInt(input.value || '0', 10) + step);
    input.value = newQty;
    await this.updateLine(item.dataset.key, newQty);
  }

  async setQuantity(event) {
    const item = event.target.closest('[data-cart-item]');
    const newQty = Math.max(0, parseInt(event.target.value || '0', 10));
    await this.updateLine(item.dataset.key, newQty);
  }

  async removeItem(event) {
    const item = event.target.closest('[data-cart-item]');
    await this.updateLine(item.dataset.key, 0);
  }

  async updateLine(key, quantity) {
    try {
      const response = await fetch(window.routes.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: 'main-cart,header' }),
      });
      const data = await response.json();
      if (data.sections) this.updateFromSectionsResponse(data.sections);
    } catch (error) {
      window.location.reload();
    }
  }

  updateFromSectionsResponse(sections) {
    if (sections['main-cart']) {
      const doc = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
      const newBody = doc.querySelector('[data-cart-page-body]');
      if (newBody && this.body) this.body.innerHTML = newBody.innerHTML;
    }
    if (sections['header']) {
      const doc = new DOMParser().parseFromString(sections['header'], 'text/html');
      const newCount = doc.querySelector('[data-cart-count]');
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        if (newCount) {
          el.textContent = newCount.textContent;
          el.classList.toggle('hidden', newCount.classList.contains('hidden'));
        }
      });
    }
  }
}

customElements.define('cart-page-items', CartPageItems);
